<script>
import axios from 'axios'
import { swalResponse, notify } from '@/utils.js'
function getEmpty() {
    return {
        name: '',
        company: '',
        title: '',
        email: '',
        phone: '',
        country: '',
        language: '',
        preferredContact: '',
        connectionType: '',
        bridgerocksArea: '',
        investorProfile: '',
        investmentInterest: '',
        capitalRange: '',
        investmentTimeframe: '',
        realEstateInterest: '',
        realEstateRelationship: '',
        partnershipArea: '',
        partnershipType: '',
        technologyArea: '',
        beyondOrgType: '',
        professionalDiscipline: '',
        mediaInquiryType: '',
        careerCategory: '',
        opportunityStage: '',
        preferredTiming: '',
        message: '',
        supportingDocuments: null,
        privacy: false,
    }
}
function formatContactQuery(formData, target) {
    let formated = {
        working_context: target.selectedTypeOfInquiry,
        full_name: formData.name,
        email: formData.email,
        phone: formData.phone,
        extra_field_1: formData.country,
        extra_field_1_label: 'country',
        extra_field_2: formData.preferredContact,
        extra_field_2_label: 'preferred contact method',
        extra_field_3: formData.company,
        extra_field_3_label: 'company',
        extra_field_4: formData.title,
        extra_field_4_label: 'title',
        message: formData.message,
        // formData: formData
    };
    console.log('formatContactQuery', formated, formData, target)
    return formated;
}

export default {
    name: 'ContactForm',
    props: {
        debug: {
            type: Boolean,
            default: false
        },
        askCompanyAndTitle: {
            type: Boolean,
            default: false
        },
        showBridgerocksArea: {
            type: Boolean,
            default: false
        },
        countries: {
            type: Array,
            default: () => [
                'United States',
                'Canada',
                'Mexico',
                'Costa Rica',
                'Panama',
                'Colombia',
                'United Kingdom',
                'Germany',
                'France',
                'Spain',
                'Italy',
                'Australia',
                'New Zealand',
                'Japan',
                'Singapore',
                'Hong Kong',
                'India',
                'Brazil',
                'Argentina',
                'Chile',
            ],
        },

        connectionTypes: {
            type: Array,
            default: () => [
                'General Inquiry',
                'Investment & Capital',
                'Real Estate & Hospitality',
                'Strategic Partnership or Joint Venture',
                'Technology & Venture Opportunities',
                'Land or Property Submission',
                'Professional Services or Supplier Introduction',
                'Media, Institutional or Community Inquiry',
                'Careers & Talent',
                'Existing Relationship or Project Follow-Up',
                'General Corporate Inquiry',
                'Other',
            ],
        },
        bridgerocksAreas: {
            type: Array,
            default: () => [
                'Bridgerocks Group',
                // 'Bridgerocks Foundation',
                'Bridgerocks Corporate Management & Operations',
                'Reyrock Properties',
                'Reyrock Talents',
                'Reyrock Ventures',
                // 'The Elements Collection',
                // 'Another Elements destination',
                // 'PneumaRica — Costa Rica',
                // 'Beynd',
                'Not sure — please direct my inquiry',
            ],
        },
        contactMethods: {
            type: Array,
            default: () => [
                'Email',
                'Telephone',
                'Video Meeting',
            ],
        },
        opportunityStages: {
            type: Array,
            default: () => [
                'Initial idea or exploratory discussion',
                'Research and feasibility',
                'Property or opportunity identified',
                'Due diligence',
                'Financing or capital formation',
                'Design and planning',
                'Pre-development',
                'Construction or implementation',
                'Operating business or active project',
                'Expansion or restructuring',
                'Not applicable',
            ],
        },
        preferredTimings: {
            type: Array,
            default: () => [
                'As soon as possible',
                'Within 30 days',
                'Within 3 months',
                'Within 6 months',
                'Within 12 months',
                'Long-term or exploratory',
                'No specific timeline',
            ],
        },
        investorProfiles: {
            type: Array,
            default: () => [
                'Private investor',
                'Family office',
                'Institutional investor',
                'Strategic corporate investor',
                'Lender or private credit provider',
                'Development or construction financier',
                'Investment advisor, broker or intermediary',
                'Fund, REIT or public-markets professional',
                'Other',
            ],
        },
        investmentInterests: {
            type: Array,
            default: () => [
                'Real estate development',
                'Hospitality and condo-hotel ownership',
                'Project debt or private credit',
                'Convertible financing',
                'Project equity',
                'Land acquisition or development finance',
                'Management and operating platform',
                'Technology or venture investment',
                'Beynd',
                'General Bridgerocks opportunities',
            ],
        },
        capitalRanges: {
            type: Array,
            default: () => [
                'Under CAD/USD $50,000',
                '$50,000–$250,000',
                '$250,000–$1 million',
                '$1 million–$5 million',
                'More than $5 million',
                'Prefer to discuss privately',
            ],
        },
        investmentTimeframes: {
            type: Array,
            default: () => [
                'Immediately',
                'Within 3 months',
                'Within 6 months',
                'Within 12 months',
                'Exploring future opportunities',
            ],
        },
        realEstateInterests: {
            type: Array,
            default: () => [
                'Purchase or ownership opportunity',
                'The Elements Collection',
                'PneumaRica',
                'Development partnership',
                'Hospitality operations',
                'Condo-hotel management',
                'Architecture or project design',
                'Construction or development',
                'Sales or brokerage',
                'Sports, wellness or performance programming',
                'Restaurant, food and beverage operations',
                'Destination or tourism partnership',
                'Other',
            ],
        },
        realEstateRelationships: {
            type: Array,
            default: () => [
                'Prospective buyer',
                'Landowner',
                'Developer',
                'Hotel or resort operator',
                'Architect or designer',
                'Contractor or construction professional',
                'Broker or sales representative',
                'Tourism or government representative',
                'Brand or experience partner',
                'Other',
            ],
        },
        partnershipAreas: {
            type: Array,
            default: () => [
                'Real estate development',
                'Land partnership',
                'Hospitality operations',
                'Sports and performance',
                'Wellness and nutrition',
                'Tourism or destination development',
                'Technology or data',
                'Brand collaboration',
                'Distribution or business development',
                'Government or institutional cooperation',
                'Capital formation',
                'Social impact or foundation initiative',
                'Other',
            ],
        },
        partnershipTypes: {
            type: Array,
            default: () => [
                'Joint venture',
                'Strategic alliance',
                'Licensing',
                'Operating partnership',
                'Development partnership',
                'Revenue-sharing arrangement',
                'Equity partnership',
                'Pilot project',
                'Sponsorship or brand collaboration',
                'Introductory discussion',
            ],
        },
        technologyAreas: {
            type: Array,
            default: () => [
                'Beynd investment',
                'Beynd strategic partnership',
                'Sports association or league',
                'Athlete or participant development',
                'Specialist or professional integration',
                'School, academy or youth organization',
                'Data, analytics or technology integration',
                'Pilot program',
                'Intellectual property or licensing',
                'Venture seeking incubation or partnership',
                'Other',
            ],
        },
        beyondOrgTypes: {
            type: Array,
            default: () => [
                'Sports federation or association',
                'League or team',
                'School or academy',
                'Technology provider',
                'Data or analytics company',
                'Specialist or professional network',
                'Investor',
                'Brand or sponsor',
                'Public institution',
                'Other',
            ],
        },
        professionalDisciplines: {
            type: Array,
            default: () => [
                'Architecture',
                'Engineering',
                'Construction',
                'Project management',
                'Interior design',
                'Landscape architecture',
                'Environmental or sustainability services',
                'Legal',
                'Accounting, tax or finance',
                'Hospitality operations',
                'Sales and marketing',
                'Technology',
                'Equipment or materials supplier',
                'Food and beverage',
                'Sports, wellness or performance services',
                'Other',
            ],
        },
        mediaInquiryTypes: {
            type: Array,
            default: () => [
                'Media interview',
                'Speaking engagement',
                'Corporate information',
                'Government or tourism authority',
                'Academic or research inquiry',
                'Sponsorship',
                'Community initiative',
                'Bridgerocks Foundation',
                'Other',
            ],
        },
        careerCategories: {
            type: Array,
            default: () => [
                'Corporate management',
                'Real estate development',
                'Hospitality operations',
                'Technology',
                'Beynd',
                'Finance and investment',
                'Marketing and communications',
                'Architecture, engineering or construction',
                'Sports, wellness or performance',
                'Internship or student opportunity',
                'General talent introduction',
            ],
        },
    },
    data: () => ({
        isProcessing: false,
        formData: getEmpty(),
    }),
    computed: {
        selectedTypeOfInquiry() {
            return [
                this.formData.connectionType,
                this.formData.investorProfile,
                this.formData.investmentInterest,
                this.formData.capitalRange,
                this.formData.investmentTimeframe,
                this.formData.realEstateInterest,
                this.formData.realEstateRelationship,
                this.formData.partnershipArea,
                this.formData.partnershipType,
                this.formData.technologyArea,
                this.formData.beyondOrgType,
                this.formData.professionalDiscipline,
                this.formData.mediaInquiryType,
                this.formData.careerCategory,
                this.formData.opportunityStage,
                this.formData.preferredTiming,
            ].filter(Boolean).join(' / ');
        },
        isGeneralInquiry() {
            return this.formData.connectionType && this.formData.connectionType === 'General Inquiry';
        },
        isShowingAnyFields() {
            return this.showInvestmentFields || this.showRealEstateFields || this.showPartnershipFields || this.showTechnologyFields || this.showProfessionalServicesFields || this.showMediaFields || this.showCareersFields || this.showExistingRelationshipFields;
        },
        showInvestmentFields() {
            return this.formData.connectionType === 'Investment & Capital';
        },
        showRealEstateFields() {
            return this.formData.connectionType === 'Real Estate & Hospitality';
        },
        showPartnershipFields() {
            return this.formData.connectionType === 'Strategic Partnership or Joint Venture';
        },
        showTechnologyFields() {
            return this.formData.connectionType === 'Technology & Venture Opportunities';
        },
        showProfessionalServicesFields() {
            return this.formData.connectionType === 'Professional Services or Supplier Introduction';
        },
        showMediaFields() {
            return this.formData.connectionType === 'Media, Institutional or Community Inquiry';
        },
        showCareersFields() {
            return this.formData.connectionType === 'Careers & Talent';
        },
        showExistingRelationshipFields() {
            return this.formData.connectionType === 'Existing Relationship or Project Follow-Up';
        },
    },
    methods: {
        async submitForm($event) {
            $event.preventDefault();
            this.isProcessing = true;
            try {
                const response = await axios.post('contacto', formatContactQuery(this.formData, this));
                swalResponse(response)
                if(response && response.status)
                    this.formData = getEmpty();
            } catch (e) {
                console.error('Error in submitForm:', e);
                notify('Error submitting form', 'error');
            } finally {
                this.isProcessing = false;
            }
        },
        // Add your methods here
        connectionTypeChanged( ) {
            this.formData.language = '';
            this.formData.bridgerocksArea = '';
            this.formData.investorProfile = '';
            this.formData.investmentInterest = '';
            this.formData.capitalRange = '';
            this.formData.investmentTimeframe = '';
            this.formData.realEstateInterest = '';
            this.formData.realEstateRelationship = '';
            this.formData.partnershipArea = '';
            this.formData.partnershipType = '';
            this.formData.technologyArea = '';
            this.formData.beyondOrgType = '';
            this.formData.professionalDiscipline = '';
            this.formData.mediaInquiryType = '';
            this.formData.careerCategory = '';
            this.formData.opportunityStage = '';
            this.formData.preferredTiming = '';
        }
    },
};
</script>

<template>
    <form id="contact-form" action="#" @submit.prevent="submitForm">

        <!-- <pre>selectedTypeOfInquiry: {{ selectedTypeOfInquiry }}</pre> -->

        <div id="full-name" class="form__group">

            <label for="name">

                {{ 'Full Name' | i18n }} *

            </label>

            <input v-model="formData.name" type="text" id="name" name="name" required>

        </div>

        <div class="form__row" v-if="askCompanyAndTitle">

            <div id="company" class="form__group">

                <label for="company">

                    {{ 'Company' | i }}

                </label>

                <input v-model="formData.company" type="text" id="company" name="company">

            </div>

            <div id="title" class="form__group">

                <label for="title">

                    {{ 'Title' | i }}

                </label>

                <input v-model="formData.title" type="text" id="title" name="title">

            </div>

        </div>

        <div id="contact-info" class="form__row">

            <div class="form__group">

                <label for="email">

                    {{ 'Email Address' | i }} *

                </label>

                <input v-model="formData.email" type="email" id="email" name="email" required>

            </div>

            <div class="form__group">

                <label for="phone">

                    {{ 'Phone Number' | i }} *

                </label>

                <input v-model="formData.phone" type="tel" id="phone" name="phone" required>

            </div>

        </div>

        <div id="location-language" class="form__row">

            <div class="form__group">

                <label for="country">

                    {{ 'Country' | i }}

                </label>

                <select v-model="formData.country" id="country" name="country">

                    <option value="">{{ 'Select a country' | i }}</option>

                    <option v-for="country in countries" :key="country" :value="country">{{ country }}</option>

                </select>

            </div>

            <div id="preferred-contact" class="form__group">

                <label for="preferredContact">

                    {{ 'Preferred Contact Method' | i }}

                </label>

                <select v-model="formData.preferredContact" id="preferredContact" name="preferredContact">
                    <option value="" disabled>
                        {{ 'Select a Contact Method' | i }}
                    </option>
                    <option v-for="method in contactMethods" :key="method" :value="method">
                        {{ method }}
                    </option>
                </select>

            </div>

        </div>

        <div class="grouping-fields form__row">
            <div id="connection-type" class="form__group">

                <label for="connectionType">

                    {{ 'How can we help?' | i }} *

                </label>

                <select v-model="formData.connectionType" id="connectionType" name="connectionType"
                    @change="connectionTypeChanged()" required>
                    <option value="" disabled>
                        {{ 'Select a Connection Type' | i }}
                    </option>
                    <option v-for="type in connectionTypes" :key="type" :value="type">
                        {{ type | i }}
                    </option>
                </select>

            </div>

            <div id="bridgerocks-area" class="form__group" v-if="!isGeneralInquiry && showBridgerocksArea">

                <label for="bridgerocksArea">

                    {{ 'Bridgerocks Area' | i }}

                </label>

                <select v-model="formData.bridgerocksArea" id="bridgerocksArea" name="bridgerocksArea">
                    <option value="" disabled>
                        {{ 'Select a Bridgerocks Area' | i }}
                    </option>
                    <option v-for="area in bridgerocksAreas" :key="area" :value="area">
                        {{ area | i }}
                    </option>
                </select>

            </div>
        </div>


        <!-- <hr v-if="formData.connectionType"> -->

        <div class="grouping-fields" v-if="isShowingAnyFields && !isGeneralInquiry">
            <div v-if="showInvestmentFields">

                <!-- <div class="form__row"> -->
                <div id="investor-profile" class="form__group">

                    <label for="investorProfile">

                        {{ 'Investor Profile' | i }}

                    </label>

                    <select v-model="formData.investorProfile" id="investorProfile" name="investorProfile">
                        <option value="" disabled>
                            {{ 'Select an Investor Profile' | i }}
                        </option>
                        <option v-for="profile in investorProfiles" :key="profile" :value="profile">
                            {{ profile | i }}
                        </option>
                    </select>

                </div>

                <div id="investment-interest" class="form__group">

                    <label for="investmentInterest">

                        {{ 'Investment Interest' | i }}

                    </label>

                    <select v-model="formData.investmentInterest" id="investmentInterest" name="investmentInterest">
                        <option value="" disabled>
                            {{ 'Select an Investment Interest' | i }}
                        </option>
                        <option v-for="interest in investmentInterests" :key="interest" :value="interest">
                            {{ interest | i }}
                        </option>
                    </select>

                </div>
                <!-- </div> -->

                <!-- <div class="form__row"> -->
                <div id="capital-range" class="form__group">

                    <label for="capitalRange">

                        {{ 'Capital Range' | i }}

                    </label>

                    <select v-model="formData.capitalRange" id="capitalRange" name="capitalRange">
                        <option value="" disabled>
                            {{ 'Select a Capital Range' | i }}
                        </option>
                        <option v-for="range in capitalRanges" :key="range" :value="range">
                            {{ range | i }}
                        </option>
                    </select>

                </div>

                <div id="investment-timeframe" class="form__group">

                    <label for="investmentTimeframe">

                        {{ 'Investment Timeframe' | i }}

                    </label>

                    <select v-model="formData.investmentTimeframe" id="investmentTimeframe" name="investmentTimeframe">
                        <option value="" disabled>
                            {{ 'Select a Timeframe' | i }}
                        </option>
                        <option v-for="timeframe in investmentTimeframes" :key="timeframe" :value="timeframe">
                            {{ timeframe | i }}
                        </option>
                    </select>

                </div>
                <!-- </div> -->

            </div>

            <div v-if="showRealEstateFields">

                <div id="real-estate-interest" class="form__group">

                    <label for="realEstateInterest">

                        {{ 'Real Estate Interest' | i }}

                    </label>

                    <select v-model="formData.realEstateInterest" id="realEstateInterest" name="realEstateInterest">
                        <option value="" disabled>
                            {{ 'Select an Interest' | i }}
                        </option>
                        <option v-for="interest in realEstateInterests" :key="interest" :value="interest">
                            {{ interest | i }}
                        </option>
                    </select>

                </div>

                <div id="real-estate-relationship" class="form__group">

                    <label for="realEstateRelationship">

                        {{ 'Your Relationship' | i }}

                    </label>

                    <select v-model="formData.realEstateRelationship" id="realEstateRelationship"
                        name="realEstateRelationship">
                        <option value="" disabled>
                            {{ 'Select a Relationship' | i }}
                        </option>
                        <option v-for="relationship in realEstateRelationships" :key="relationship"
                            :value="relationship">
                            {{ relationship | i }}
                        </option>
                    </select>

                </div>

            </div>

            <div v-if="showPartnershipFields">

                <div id="partnership-area" class="form__group">

                    <label for="partnershipArea">

                        {{ 'Partnership Area' | i }}

                    </label>

                    <select v-model="formData.partnershipArea" id="partnershipArea" name="partnershipArea">
                        <option value="" disabled>
                            {{ 'Select a Partnership Area' | i }}
                        </option>
                        <option v-for="area in partnershipAreas" :key="area" :value="area">
                            {{ area | i }}
                        </option>
                    </select>

                </div>

                <div id="partnership-type" class="form__group">

                    <label for="partnershipType">

                        {{ 'Partnership Type' | i }}

                    </label>

                    <select v-model="formData.partnershipType" id="partnershipType" name="partnershipType">
                        <option value="" disabled>
                            {{ 'Select a Partnership Type' | i }}
                        </option>
                        <option v-for="type in partnershipTypes" :key="type" :value="type">
                            {{ type | i }}
                        </option>
                    </select>

                </div>

            </div>

            <div v-if="showTechnologyFields">

                <div id="technology-area" class="form__group">

                    <label for="technologyArea">

                        {{ 'Technology Area' | i }}

                    </label>

                    <select v-model="formData.technologyArea" id="technologyArea" name="technologyArea">
                        <option value="" disabled>
                            {{ 'Select a Technology Area' | i }}
                        </option>
                        <option v-for="area in technologyAreas" :key="area" :value="area">
                            {{ area | i }}
                        </option>
                    </select>

                </div>

                <div id="beyond-org-type" class="form__group">

                    <label for="beyondOrgType">

                        {{ 'Organization Type' | i }}

                    </label>

                    <select v-model="formData.beyondOrgType" id="beyondOrgType" name="beyondOrgType">
                        <option value="" disabled>
                            {{ 'Select an Organization Type' | i }}
                        </option>
                        <option v-for="type in beyondOrgTypes" :key="type" :value="type">
                            {{ type | i }}
                        </option>
                    </select>

                </div>

            </div>

            <div v-if="showProfessionalServicesFields">

                <div id="professional-discipline" class="form__group">

                    <label for="professionalDiscipline">

                        {{ 'Professional Discipline' | i }}

                    </label>

                    <select v-model="formData.professionalDiscipline" id="professionalDiscipline"
                        name="professionalDiscipline">
                        <option value="" disabled>
                            {{ 'Select a Discipline' | i }}
                        </option>
                        <option v-for="discipline in professionalDisciplines" :key="discipline" :value="discipline">
                            {{ discipline | i }}
                        </option>
                    </select>

                </div>

            </div>

            <div v-if="showMediaFields">

                <div id="media-inquiry-type" class="form__group">

                    <label for="mediaInquiryType">

                        {{ 'Media Inquiry Type' | i }}

                    </label>

                    <select v-model="formData.mediaInquiryType" id="mediaInquiryType" name="mediaInquiryType">
                        <option value="" disabled>
                            {{ 'Select an Inquiry Type' | i }}
                        </option>
                        <option v-for="type in mediaInquiryTypes" :key="type" :value="type">
                            {{ type | i }}
                        </option>
                    </select>

                </div>

            </div>

            <div v-if="showCareersFields">

                <div id="career-category" class="form__group">

                    <label for="careerCategory">

                        {{ 'Career Category' | i }}

                    </label>

                    <select v-model="formData.careerCategory" id="careerCategory" name="careerCategory">
                        <option value="" disabled>
                            {{ 'Select a Career Category' | i }}
                        </option>
                        <option v-for="category in careerCategories" :key="category" :value="category">
                            {{ category | i }}
                        </option>
                    </select>

                </div>

            </div>

            <div v-if="showExistingRelationshipFields">

                <div id="opportunity-stage" class="form__group">

                    <label for="opportunityStage">

                        {{ 'Opportunity Stage' | i }}

                    </label>

                    <select v-model="formData.opportunityStage" id="opportunityStage" name="opportunityStage">
                        <option value="" disabled>
                            {{ 'Select an Opportunity Stage' | i }}
                        </option>
                        <option v-for="stage in opportunityStages" :key="stage" :value="stage">
                            {{ stage | i }}
                        </option>
                    </select>

                </div>

                <div id="preferred-timing" class="form__group">

                    <label for="preferredTiming">

                        {{ 'Preferred Timing' | i }}

                    </label>

                    <select v-model="formData.preferredTiming" id="preferredTiming" name="preferredTiming">
                        <option value="" disabled>
                            {{ 'Select a Timing' | i }}
                        </option>
                        <option v-for="timing in preferredTimings" :key="timing" :value="timing">
                            {{ timing | i }}
                        </option>
                    </select>

                </div>

            </div>
        </div>

        <div class="grouping-fields" v-if="isGeneralInquiry || !isShowingAnyFields">
            <!-- <hr> -->
            <div id="project-description" class="form__group">

                <label for="message">

                    {{ 'How can we help you?' | i }} *

                </label>

                <textarea v-model="formData.message" id="message" name="message" rows="6" required></textarea>

            </div>

        </div>

        <div class="grouping-fields" v-else-if="isShowingAnyFields">
            <!-- <hr> -->
            <div id="project-description" class="form__group">

                <label for="message">

                    {{ 'Tell Us About Your Project' | i }} *

                </label>

                <textarea v-model="formData.message" id="message" name="message" rows="6" required></textarea>

            </div>

        </div>


        <div id="privacy-policy-acceptance" class="form__checkbox">

            <input v-model="formData.privacy" type="checkbox" id="privacy" required>

            <label for="privacy">

                {{ 'i_agree_to_the' | i }}
                <a :href="'site_br_pp' | cr" target="_blank">{{ 'Privacy Policy' | i }}</a>
                {{ '_and_' | i }}
                <a :href="'site_br_tc' | cr" target="_blank">{{ 'Terms of Service' | i }}</a>.

            </label>

        </div>

        <button type="submit" class="btn btn--gold" :disabled="isProcessing">
            {{ (isProcessing ? 'Sending...' : 'Send Message') | i }}
        </button>

        <pre v-if="debug">{{ formData }}</pre>

    </form>
</template>

<style lang="scss">
#contact-form {
    hr {
        margin-bottom: 1.75em;
        border: 1px solid #e1ded8;
    }

    .form__checkbox {
        a {

            &,
            &:hover,
            &:visited {
                text-decoration: underline;
                font-weight: bold;
            }

            &:hover {
                color: var(--primary);
            }
        }
    }

    .grouping-fields {
        background-color: #e1ded87a;
        padding: 1.5em;
        margin-bottom: 1.5em;
        border-radius: 4px;

        &.form__row {
            .form__group:nth-last-child(2) {
                margin-bottom: 0em;
            }
        }

        .form__group:last-child {
            margin-bottom: 0em;
        }

        &+.grouping-fields {
            margin-top: 1.5em;
        }
    }
}
</style>